<template>
    <div :class="getCSSClass('repository-file-picker-container')">
        <input type="text" readonly v-bind:value="fileLabel" :class="getCSSClass('repository-file-picker-input')">
        <button :class="getCSSClass('repository-file-picker-button')"
                type="button"
                v-on:click="showPopup = true"
                v-html="icon('pick')+translate('Kiválasztás')"></button>
        <popup :visible="showPopup"
               v-on:close="showPopup = false"
        >
            <div :class="getCSSClass('repository-file-picker-popup-inner')">
                <div :class="getCSSClass('repository-manager-function-popup-row')">
                    <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Mappa')"></label> </div>
                    <div :class="getCSSClass('repository-manager-function-popup-column')">
                        <repository-folder-picker :repository="repository"
                                                  :operations-url="operationsUrl"
                                                  :key="folderPickerKey"
                                                  v-model="folder"
                                                  v-on:path="currentPath = $event"
                                                  v-on:files="files = $event; selectedFileIndex = -1"></repository-folder-picker>

                    </div>
                </div>
                <div :class="getCSSClass('repository-manager-function-popup-row')">
                    <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Fájlok')"></label> </div>
                    <div :class="getCSSClass('repository-manager-function-popup-column')">
                        <select v-model="selectedFileIndex" size="10">
                            <option v-for="file, index in files"
                                    :value="index"
                                    v-html="file.name"></option>
                        </select>
                    </div>
                </div>
                <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                    <button :class="getCSSClass('repository-manager-popup-save-button')"
                            v-on:click="selectFile"
                            type="button"
                    ><span v-html="icon('save')" class="mr-2"></span><span v-html="translate('Kiválaszt')"></span>
                    </button>
                    <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                            type="button"
                            v-on:click="cancel"
                    ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                    </button>
                    <button :class="getCSSClass('repository-manager-popup-upload-button')"
                            type="button"
                            v-on:click="showUpload"
                    ><span v-html="icon('new')" class="mr-2"></span><span v-html="translate('Feltöltés')"></span>
                    </button>
                </div>

            </div>
            <popup :visible="showUploadPopup"
                   v-on:close="showUploadPopup = false">
                <repository-upload-component
                    :repository="repository"
                    :repository-slug="repository.slug"
                    :operations-url="operationsUrl"
                    :current-path="currentPath"
                    :max-uploadable-files="1"
                    v-on:uploaderror="alert(error)"
                    v-on:uploadqueue="handleUploadQueue"
                    v-on:close="cancel"
                ></repository-upload-component>
            </popup>
        </popup>
    </div>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            repository: {type: Object},
            operationsUrl: {type: String},
            value: {}
        },
        data: function () {
            return {
                folderPickerKey: 0,
                showPopup: false,
                showUploadPopup: false,
                files: [],
                folder: null,
                selectedFileIndex: -1,
                currentPath: [],
            }
        },
        mounted() {
        },
        methods: {
            selectFile: function() {
                let v = this.files[this.selectedFileIndex] ? this.files[this.selectedFileIndex] : null
                this.$emit('input', v);
                this.showPopup = false;
            },
            cancel: function() {
                this.showPopup = false;
            },
            showUpload: function() {
                this.showUploadPopup = true;
            },
            handleUploadQueue: function(payload) {
                if (payload.length == 0) {
                    this.showUploadPopup = false;
                    this.folderPickerKey++
                }
            }
        },
        computed: {
            fileLabel: function() {
                if ((this.value) && (this.value.name)) {
                    return this.value.name;
                }
                return '';
            }
        },
        watch: {
            showPopup: function() {
                this.folderPickerKey++;
            }
        }

    }
</script>
